import { Mapper } from "../../../../core/base";
import { ProductWebEntity } from "./product.web-entity";
import { Product } from "../../../../core/domain/models";

export class ProductWebRepositoryMapper extends Mapper<ProductWebEntity, Product> {
  mapFrom(param: ProductWebEntity): Product {
    return {
      id: param.id,
      name: param.name,
      daoLocationKey: "",
      segment : "",
      shouldVisitIfNoService: false,
      productKeyMapping: false,
      keyValueData: undefined
    };
  }

  mapTo(param: Product): ProductWebEntity {
    return {
      id: param.id,
      name: param.name
    };
  }
}
